<template>
  <div class="yk-test-wrap">
    <header class="yk-header">
      <h1>Yurtiçi Kargo API Test Konsolu</h1>
      <p class="yk-subtitle">
        Gizli geliştirici aracı — test ortamı çağrıları için. Backend mevcut JWT ile çalışır;
        hangi <code>paymentType</code> seçilirse arka planda ilgili wsUser kullanılır.
      </p>
    </header>

    <section class="yk-quick-actions">
      <div class="yk-quick-row">
        <div>
          <strong>Sync Job (30dk'da bir otomatik)</strong>
          <div class="yk-quick-sub">Aktif kargoları (NULL/NOP/ISR/IND) sorgular, statü değiştiyse Idia'ya bildirir.</div>
        </div>
        <button class="yk-btn primary" :disabled="syncRunning" @click="runSyncNow">
          {{ syncRunning ? 'Çalışıyor...' : 'Sync Şimdi Çalıştır' }}
        </button>
      </div>
      <pre v-if="syncResult" class="yk-quick-result">{{ syncResult }}</pre>
    </section>

    <nav class="yk-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        :class="['yk-tab', { active: activeTab === tab.id }]"
        @click="activeTab = tab.id"
      >
        {{ tab.label }}
      </button>
    </nav>

    <section class="yk-panel">
      <!-- createShipment -->
      <div v-if="activeTab === 'create'">
        <h2>createShipment — Gönderi Oluştur</h2>

        <div class="yk-prefill">
          <div class="yk-prefill-row">
            <label>Order ID'den Otomatik Doldur</label>
            <div class="yk-prefill-input">
              <input v-model.number="prefill.orderId" type="number" placeholder="örn 361970">
              <button class="yk-btn ghost" :disabled="prefill.loading || !prefill.orderId" @click="loadFromOrder">
                {{ prefill.loading ? 'Yükleniyor...' : 'Yükle' }}
              </button>
            </div>
          </div>
          <p v-if="prefill.message" class="yk-prefill-msg" :class="{ error: prefill.isError }">{{ prefill.message }}</p>
        </div>

        <div class="yk-row">
          <label>Ödeme Tipi</label>
          <select v-model.number="create.paymentType">
            <option :value="0">SenderPaid (GÖ)</option>
            <option :value="1">ReceiverPaid (AÖ)</option>
            <option :value="2">SenderPaidCod</option>
            <option :value="3">ReceiverPaidCod</option>
          </select>
        </div>

        <div v-for="(order, idx) in create.orders" :key="idx" class="yk-order-card">
          <div class="yk-order-head">
            <strong>Order #{{ idx + 1 }}</strong>
            <button class="yk-btn-mini danger" @click="removeOrder(idx)" v-if="create.orders.length > 1">Sil</button>
          </div>
          <div class="yk-grid">
            <div><label>cargoKey *</label><input v-model="order.cargoKey" placeholder="ZZZZ0123457"></div>
            <div><label>invoiceKey *</label><input v-model="order.invoiceKey" placeholder="ZZZZ0123457"></div>
            <div><label>receiverCustName * (min 5 char, ≥4 harf)</label><input v-model="order.receiverCustName" placeholder="MEHMET YILMAZ"></div>
            <div><label>receiverPhone1 * (10 hane)</label><input v-model="order.receiverPhone1" placeholder="2123652426"></div>
            <div class="yk-full"><label>receiverAddress * (5-200 char)</label><input v-model="order.receiverAddress" placeholder="Eski Büyükdere Cad. No 3/7"></div>
            <div><label>cityName</label><input v-model="order.cityName" placeholder="İstanbul"></div>
            <div><label>townName</label><input v-model="order.townName" placeholder="Şişli"></div>
            <div><label>cargoCount</label><input v-model.number="order.cargoCount" type="number" placeholder="1"></div>
            <div><label>desi</label><input v-model.number="order.desi" type="number" step="0.001" placeholder="3.5"></div>
            <div><label>kg</label><input v-model.number="order.kg" type="number" step="0.001" placeholder="7.6"></div>
            <div><label>waybillNo</label><input v-model="order.waybillNo" placeholder="A123456 (ticari için zorunlu)"></div>
            <div><label>specialField1 (örn. 3$SP-001#)</label><input v-model="order.specialField1" placeholder="3$SP-2026-0001#"></div>
            <div><label>orgReceiverCustId</label><input v-model="order.orgReceiverCustId" placeholder="11988"></div>
            <div><label>emailAddress</label><input v-model="order.emailAddress" placeholder="alici@example.com"></div>
            <div><label>description</label><input v-model="order.description" placeholder="Açıklama"></div>
            <div><label>taxNumber (10/11 hane)</label><input v-model="order.taxNumber" placeholder=""></div>
          </div>
        </div>

        <div class="yk-actions">
          <button class="yk-btn ghost" @click="addOrder">+ Order Ekle</button>
          <button class="yk-btn primary" :disabled="loading" @click="callCreate">
            {{ loading ? 'Gönderiliyor...' : 'createShipment Çağır' }}
          </button>
        </div>
      </div>

      <!-- cancelShipment -->
      <div v-if="activeTab === 'cancel'">
        <h2>cancelShipment — Gönderi İptal</h2>
        <div class="yk-row">
          <label>Ödeme Tipi</label>
          <select v-model.number="cancel.paymentType">
            <option :value="0">SenderPaid</option>
            <option :value="1">ReceiverPaid</option>
            <option :value="2">SenderPaidCod</option>
            <option :value="3">ReceiverPaidCod</option>
          </select>
        </div>
        <div class="yk-row">
          <label>cargoKeys (her satıra bir kod)</label>
          <textarea v-model="cancel.cargoKeysText" rows="6" placeholder="0001231&#10;0001232&#10;00001134"></textarea>
        </div>
        <div class="yk-actions">
          <button class="yk-btn primary" :disabled="loading" @click="callCancel">
            {{ loading ? 'Gönderiliyor...' : 'cancelShipment Çağır' }}
          </button>
        </div>
      </div>

      <!-- queryShipment -->
      <div v-if="activeTab === 'query'">
        <h2>queryShipment — Gönderi Sorgula</h2>
        <div class="yk-row">
          <label>Ödeme Tipi</label>
          <select v-model.number="query.paymentType">
            <option :value="0">SenderPaid</option>
            <option :value="1">ReceiverPaid</option>
            <option :value="2">SenderPaidCod</option>
            <option :value="3">ReceiverPaidCod</option>
          </select>
        </div>
        <div class="yk-row">
          <label>keyType</label>
          <select v-model.number="query.keyType">
            <option :value="0">CargoKey (0)</option>
            <option :value="1">InvoiceKey (1)</option>
          </select>
        </div>
        <div class="yk-row">
          <label>keys (her satıra bir kod)</label>
          <textarea v-model="query.keysText" rows="5" placeholder="608806727046"></textarea>
        </div>
        <div class="yk-row inline">
          <label><input type="checkbox" v-model="query.addHistoricalData"> addHistoricalData (taşıma hareketleri)</label>
          <label><input type="checkbox" v-model="query.onlyTracking"> onlyTracking (sadece takip linki)</label>
        </div>
        <div class="yk-actions">
          <button class="yk-btn primary" :disabled="loading" @click="callQuery">
            {{ loading ? 'Sorgulanıyor...' : 'queryShipment Çağır' }}
          </button>
        </div>
        <p class="yk-note">⚠ YK throttle: aynı sorgu 1 dakika içinde tekrarlanırsa exception. Backend 5dk cache uygular.</p>
      </div>

      <!-- saveReturnShipmentCode -->
      <div v-if="activeTab === 'return'">
        <h2>saveReturnShipmentCode — RMA İade Kodu Oluştur</h2>
        <div class="yk-row">
          <label>Ödeme Tipi</label>
          <select v-model.number="ret.paymentType">
            <option :value="0">SenderPaid</option>
            <option :value="1">ReceiverPaid</option>
          </select>
        </div>
        <div class="yk-grid two">
          <div><label>returnCode *</label><input v-model="ret.returnCode" placeholder="RTN-2026-0001"></div>
          <div><label>maxCount *</label><input v-model.number="ret.maxCount" type="number" min="1"></div>
          <div><label>startDate *</label><input v-model="ret.startDate" type="date"></div>
          <div><label>endDate *</label><input v-model="ret.endDate" type="date"></div>
          <div class="yk-full"><label>fieldName (boş = otomatik: test'te 53, canlı'da 16)</label><input v-model="ret.fieldName" placeholder=""></div>
        </div>
        <div class="yk-actions">
          <button class="yk-btn primary" :disabled="loading" @click="callReturn">
            {{ loading ? 'Gönderiliyor...' : 'saveReturnShipmentCode Çağır' }}
          </button>
        </div>
      </div>

      <!-- trackingUrl -->
      <div v-if="activeTab === 'tracking'">
        <h2>BuildTrackingUrl — Takip Linki Oluştur</h2>
        <div class="yk-grid two">
          <div>
            <label>Field Tipi</label>
            <select v-model.number="track.field">
              <option :value="3">3 — Sipariş No</option>
              <option :value="53">53 — Anahtar Alan (YK barkod)</option>
              <option :value="54">54 — Sevk İrsaliye No</option>
              <option :value="2">2 — Müşteri Seri No</option>
              <option :value="14">14 — Müşteri Kargo Ref Kodu</option>
              <option :value="99">99 — Müşteri Sevk İrsaliyesi (Self Servis)</option>
            </select>
          </div>
          <div><label>Reference Number *</label><input v-model="track.referenceNumber" placeholder="SP-2026-0001"></div>
          <div class="yk-full"><label>Shipment Date *</label><input v-model="track.shipmentDate" type="date"></div>
        </div>
        <div class="yk-actions">
          <button class="yk-btn primary" :disabled="loading" @click="callTracking">
            {{ loading ? 'Üretiliyor...' : 'TrackingUrl Üret' }}
          </button>
        </div>
      </div>
    </section>

    <section class="yk-response" v-if="response || error">
      <header class="yk-resp-head">
        <strong>{{ error ? 'HATA' : 'YANIT' }}</strong>
        <button class="yk-btn-mini" @click="clearResponse">Temizle</button>
      </header>
      <pre v-if="response" class="yk-resp-body">{{ formattedResponse }}</pre>
      <pre v-if="error" class="yk-resp-body error">{{ error }}</pre>
    </section>
  </div>
</template>

<script>
import yurticiKargoApi from '@/api/yurticiKargo';

const blankOrder = () => ({
  cargoKey: '',
  invoiceKey: '',
  receiverCustName: '',
  receiverAddress: '',
  receiverPhone1: '',
  cityName: '',
  townName: '',
  cargoCount: 1,
  desi: null,
  kg: null,
  waybillNo: '',
  specialField1: '',
  orgReceiverCustId: '',
  emailAddress: '',
  description: '',
  taxNumber: ''
});

export default {
  name: 'YurticiKargoTest',
  data() {
    const today = new Date().toISOString().slice(0, 10);
    const monthLater = new Date(Date.now() + 30 * 24 * 3600 * 1000).toISOString().slice(0, 10);
    return {
      activeTab: 'create',
      tabs: [
        { id: 'create', label: 'createShipment' },
        { id: 'cancel', label: 'cancelShipment' },
        { id: 'query', label: 'queryShipment' },
        { id: 'return', label: 'saveReturnShipmentCode' },
        { id: 'tracking', label: 'TrackingUrl' }
      ],
      loading: false,
      response: null,
      error: null,
      create: { paymentType: 0, orders: [blankOrder()] },
      cancel: { paymentType: 0, cargoKeysText: '' },
      query: { paymentType: 0, keyType: 0, keysText: '', addHistoricalData: true, onlyTracking: false },
      ret: { paymentType: 0, returnCode: '', maxCount: 1, startDate: today, endDate: monthLater, fieldName: '' },
      track: { field: 3, referenceNumber: '', shipmentDate: today },
      prefill: { orderId: null, loading: false, message: '', isError: false },
      syncRunning: false,
      syncResult: null
    };
  },
  computed: {
    formattedResponse() {
      try { return JSON.stringify(this.response, null, 2); } catch (e) { return String(this.response); }
    }
  },
  methods: {
    addOrder() { this.create.orders.push(blankOrder()); },
    removeOrder(idx) { this.create.orders.splice(idx, 1); },
    clearResponse() { this.response = null; this.error = null; },
    cleanOrder(o) {
      const out = {};
      Object.keys(o).forEach(k => {
        const v = o[k];
        if (v !== '' && v !== null && v !== undefined) out[k] = v;
      });
      return out;
    },
    parseLines(text) {
      return (text || '').split('\n').map(s => s.trim()).filter(s => s.length > 0);
    },
    async run(promiseFactory) {
      this.loading = true;
      this.response = null;
      this.error = null;
      try {
        const r = await promiseFactory();
        this.response = r.data;
      } catch (e) {
        const data = e.response && e.response.data;
        this.error = data ? JSON.stringify(data, null, 2) : (e.message || String(e));
      } finally {
        this.loading = false;
      }
    },
    callCreate() {
      const payload = {
        paymentType: this.create.paymentType,
        orders: this.create.orders.map(o => this.cleanOrder(o))
      };
      this.run(() => yurticiKargoApi.createShipment(payload));
    },
    callCancel() {
      const payload = {
        paymentType: this.cancel.paymentType,
        cargoKeys: this.parseLines(this.cancel.cargoKeysText)
      };
      this.run(() => yurticiKargoApi.cancelShipment(payload));
    },
    callQuery() {
      const payload = {
        paymentType: this.query.paymentType,
        keyType: this.query.keyType,
        keys: this.parseLines(this.query.keysText),
        addHistoricalData: this.query.addHistoricalData,
        onlyTracking: this.query.onlyTracking
      };
      this.run(() => yurticiKargoApi.queryShipment(payload));
    },
    callReturn() {
      const payload = {
        paymentType: this.ret.paymentType,
        returnCode: this.ret.returnCode,
        maxCount: this.ret.maxCount,
        startDate: this.ret.startDate,
        endDate: this.ret.endDate,
        fieldName: this.ret.fieldName || null
      };
      this.run(() => yurticiKargoApi.saveReturnShipmentCode(payload));
    },
    callTracking() {
      const payload = {
        field: this.track.field,
        referenceNumber: this.track.referenceNumber,
        shipmentDate: this.track.shipmentDate
      };
      this.run(() => yurticiKargoApi.trackingUrl(payload));
    },
    async runSyncNow() {
      this.syncRunning = true;
      this.syncResult = null;
      try {
        const r = await yurticiKargoApi.runSyncNow();
        this.syncResult = JSON.stringify(r.data, null, 2);
      } catch (e) {
        this.syncResult = (e.response && e.response.data) ? JSON.stringify(e.response.data, null, 2) : e.message;
      } finally {
        this.syncRunning = false;
      }
    },
    async loadFromOrder() {
      this.prefill.loading = true;
      this.prefill.message = '';
      this.prefill.isError = false;
      try {
        const r = await yurticiKargoApi.prefillFromOrder(this.prefill.orderId);
        const data = r.data;
        if (data && data.shippingOrder) {
          const vo = data.shippingOrder;
          const filled = blankOrder();
          Object.keys(vo).forEach(k => {
            const lower = k.charAt(0).toLowerCase() + k.slice(1);
            if (vo[k] !== null && vo[k] !== undefined && filled.hasOwnProperty(lower))
              filled[lower] = vo[k];
          });
          this.create.orders = [filled];
          this.prefill.message = `Order #${data.orderId} (mpId=${data.mpId}) yüklendi`;
        } else if (data && data.error) {
          this.prefill.message = data.error;
          this.prefill.isError = true;
        } else {
          this.prefill.message = 'Beklenmeyen yanıt';
          this.prefill.isError = true;
        }
      } catch (e) {
        this.prefill.message = (e.response && e.response.data && e.response.data.error) || e.message;
        this.prefill.isError = true;
      } finally {
        this.prefill.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.yk-test-wrap { max-width: 1100px; margin: 24px auto; padding: 24px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; color: #1f2937; }
.yk-header h1 { font-size: 22px; margin: 0 0 6px 0; color: #111; }
.yk-subtitle { font-size: 13px; color: #555; margin: 0 0 20px 0; }
.yk-subtitle code { background: #eef2ff; padding: 1px 5px; border-radius: 3px; font-size: 12px; }

.yk-quick-actions { background: #f0f9ff; border: 1px solid #bae6fd; border-radius: 8px; padding: 14px 18px; margin-bottom: 18px; }
.yk-quick-row { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.yk-quick-row strong { font-size: 13px; color: #0c4a6e; }
.yk-quick-sub { font-size: 12px; color: #075985; margin-top: 2px; }
.yk-quick-result { background: #0f172a; color: #e2e8f0; padding: 10px 14px; border-radius: 6px; font-family: "SF Mono", Monaco, monospace; font-size: 12px; margin: 12px 0 0 0; max-height: 200px; overflow: auto; }

.yk-tabs { display: flex; gap: 4px; border-bottom: 2px solid #e5e7eb; margin-bottom: 16px; flex-wrap: wrap; }
.yk-tab { background: transparent; border: none; padding: 10px 16px; font-size: 13px; cursor: pointer; color: #6b7280; border-bottom: 2px solid transparent; margin-bottom: -2px; font-weight: 500; }
.yk-tab:hover { color: #111; }
.yk-tab.active { color: #1d4ed8; border-bottom-color: #1d4ed8; }

.yk-panel { background: #fff; padding: 20px; border: 1px solid #e5e7eb; border-radius: 8px; box-shadow: 0 1px 2px rgba(0,0,0,0.04); }
.yk-panel h2 { font-size: 16px; margin: 0 0 16px 0; color: #111; }

.yk-row { display: flex; flex-direction: column; gap: 6px; margin-bottom: 12px; }
.yk-row.inline { flex-direction: row; gap: 24px; }
.yk-row label, .yk-grid label { font-size: 12px; color: #4b5563; font-weight: 500; }
.yk-row input, .yk-row select, .yk-row textarea, .yk-grid input, .yk-grid select { width: 100%; padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 4px; font-size: 13px; box-sizing: border-box; font-family: inherit; }
.yk-row input:focus, .yk-row select:focus, .yk-row textarea:focus, .yk-grid input:focus, .yk-grid select:focus { outline: none; border-color: #1d4ed8; box-shadow: 0 0 0 3px rgba(29, 78, 216, 0.1); }

.yk-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; }
.yk-grid.two { grid-template-columns: 1fr 1fr; }
.yk-grid > div { display: flex; flex-direction: column; gap: 4px; }
.yk-grid .yk-full { grid-column: 1 / -1; }

.yk-order-card { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 6px; padding: 14px; margin-bottom: 12px; }
.yk-order-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
.yk-order-head strong { color: #111; font-size: 13px; }

.yk-actions { display: flex; gap: 8px; margin-top: 16px; justify-content: flex-end; }
.yk-btn { padding: 9px 18px; border: none; border-radius: 4px; font-size: 13px; cursor: pointer; font-weight: 500; }
.yk-btn.primary { background: #1d4ed8; color: white; }
.yk-btn.primary:hover { background: #1e40af; }
.yk-btn.primary:disabled { background: #9ca3af; cursor: not-allowed; }
.yk-btn.ghost { background: white; border: 1px solid #d1d5db; color: #374151; }
.yk-btn.ghost:hover { background: #f9fafb; }
.yk-btn-mini { background: #f3f4f6; border: 1px solid #d1d5db; padding: 4px 10px; font-size: 11px; border-radius: 3px; cursor: pointer; color: #374151; }
.yk-btn-mini.danger { background: #fee2e2; color: #991b1b; border-color: #fca5a5; }

.yk-note { font-size: 12px; color: #92400e; background: #fef3c7; padding: 8px 12px; border-radius: 4px; margin-top: 12px; }

.yk-prefill { background: #eef2ff; border: 1px solid #c7d2fe; border-radius: 6px; padding: 12px 14px; margin-bottom: 16px; }
.yk-prefill-row { display: flex; flex-direction: column; gap: 6px; }
.yk-prefill-row label { font-size: 12px; color: #3730a3; font-weight: 600; }
.yk-prefill-input { display: flex; gap: 8px; align-items: stretch; }
.yk-prefill-input input { flex: 1; padding: 8px 10px; border: 1px solid #c7d2fe; border-radius: 4px; font-size: 13px; box-sizing: border-box; font-family: inherit; }
.yk-prefill-input input:focus { outline: none; border-color: #4f46e5; box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15); }
.yk-prefill-input button { white-space: nowrap; }
.yk-prefill-msg { font-size: 12px; color: #166534; margin: 8px 0 0 0; }
.yk-prefill-msg.error { color: #991b1b; }

.yk-response { margin-top: 20px; background: #1e293b; color: #f1f5f9; border-radius: 8px; overflow: hidden; }
.yk-resp-head { display: flex; justify-content: space-between; align-items: center; padding: 10px 16px; background: #0f172a; }
.yk-resp-head strong { color: #f1f5f9; font-size: 12px; letter-spacing: 0.5px; }
.yk-resp-body { padding: 16px; margin: 0; font-family: "SF Mono", Monaco, "Cascadia Code", monospace; font-size: 12px; line-height: 1.5; max-height: 500px; overflow: auto; white-space: pre-wrap; word-wrap: break-word; }
.yk-resp-body.error { color: #fca5a5; }

@media (max-width: 768px) {
  .yk-grid { grid-template-columns: 1fr; }
  .yk-grid.two { grid-template-columns: 1fr; }
}
</style>
